// Helper functions for E&E sites that span multiple verticals i.e. China (CN)

/**
 * Derives the route needed for each vertical based on the market. Returns
 * empty string if not needed.
 * @param {string|string[]} market ['CN', 'US', 'UK', etc.]
 * @param {string} vertical ['business', 'k12', etc.]
 * @return {string}
 */
export const deriveRouteForVertical = (market, vertical) => {
    // Market is array, set as string
    const marketString = typeof market !== "string" ? market.toString() : market;
    if (marketString === "CN") {
        // China pages instances, can add others in future
        switch (vertical) {
            case "business":
                return "/business";
            case "k12":
                return "/training-centers";
            case "hed":
                return "/education";
            default:
                return "";
        }
    }
    return "";
};

/**
 * Computes the route prefix needed for sites that span multiple verticals and
 * have a single resource hub. Based on the market
 * @param {string|string[]} market
 * @return {string}
 */
export const getHubPrefixFromVertical = (market) => {
    // Market is array, set as string
    const marketString = typeof market !== "string" ? market.toString() : market;
    if (marketString === "CN") {
        return "/business";
    }
    return "";
};

/**
 * Returns bool based on whether the market has the verticals sites combined
 * into a single app
 * @param {string|string[]} market ['CN', 'US', 'UK', etc.]
 * @return {boolean}
 */
export const isCombinedVertical = (market) => market.toString().toLowerCase() === "cn";

/**
 * Returns string from siteMetadata URL and localized business word
 * @param {string} siteUrl 'https://www.rosettastone.de'
 * @param {string} businessLocalized 'unternehmen'
 * @return {string}
 */
export const buildAbsolutePath = (siteUrl, businessLocalized) => `${siteUrl}/${businessLocalized}`;
